// в обычных транзакциях есть paymentVariation
// а в транзакциях платежных систем нет, поэтому проверяем по полям
import { CARD_TYPES, TRANSACTION_TYPES } from '@expane/data'

export const isTransactionBookingPaymentWithProvider = <T extends { bookingId: number | null }>(
  transaction: T,
) => transaction.bookingId !== null

export const isTransactionGiftCardPaymentWithProvider = <
  T extends { transactionsCards: { card: { type: number } }[] },
>(
  transaction: T,
) =>
  transaction.transactionsCards.some(
    transactionCard => transactionCard.card.type === CARD_TYPES.giftCard,
  )
export const isTransactionSubscriptionPaymentWithProvider = <
  T extends { transactionsCards: { card: { type: number } }[] },
>(
  transaction: T,
) =>
  transaction.transactionsCards.some(
    transactionCard => transactionCard.card.type === CARD_TYPES.subscription,
  )

export const isThisPaymentWithProviderTransaction = <T extends { type: number }>(
  transaction: T,
): boolean => transaction.type === TRANSACTION_TYPES.paymentWithProvider.id
